import { MousePointer2, Flower2, Hand } from 'lucide-react';
import { useHasCoarsePointer } from '../../hooks/useHasCoarsePointer';

/**
 * PlantTabSidebar - 280px sidebar for the Pflanzen tab
 *
 * Mirrors GardenObjectSidebar's layout style so the left sidebar keeps
 * a consistent width (280px) across both tabs, eliminating the width
 * flicker on tab switch.
 *
 * @param {string} activeTool - Currently selected tool
 * @param {function} onToolChange - Callback(toolId) when tool is selected
 * @param {function} onOpenCatalog - Callback to open the PlantCatalogDialog
 */
const PlantTabSidebar = ({ activeTool, onToolChange, onOpenCatalog }) => {
  const isTouchDevice = useHasCoarsePointer();

  return (
    <div className="h-full flex flex-col bg-gray-50 border-r border-gray-200">
      {/* Tool cluster: Wählen + (auf Touch) Bewegen — gemeinsamer Block ohne Divider dazwischen */}
      <div className="px-4 py-3 border-b border-gray-200 bg-white space-y-2">
        <button
          onClick={() => onToolChange?.('select')}
          className={`
            w-full px-3 py-2 rounded flex items-center justify-center gap-2
            transition-all duration-150
            ${
              activeTool === 'select'
                ? 'bg-emerald-500 text-white shadow-sm'
                : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
            }
          `}
          title="Auswählen (V)"
        >
          <MousePointer2 size={18} />
          <span className="text-sm font-medium">Wählen</span>
        </button>

        {isTouchDevice && (
          <button
            onClick={() => onToolChange?.('pan')}
            className={`
              w-full px-3 py-2 rounded flex items-center justify-center gap-2
              transition-all duration-150
              ${
                activeTool === 'pan'
                  ? 'bg-emerald-500 text-white shadow-sm'
                  : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
              }
            `}
            title="Bewegen"
          >
            <Hand size={18} />
            <span className="text-sm font-medium">Bewegen</span>
          </button>
        )}
      </div>

      {/* Plant Catalog */}
      <div className="px-4 py-3">
        <button
          onClick={() => onOpenCatalog?.()}
          className="w-full px-3 py-2 rounded flex items-center justify-center gap-2
            transition-all duration-150
            bg-emerald-50 text-emerald-700 hover:bg-emerald-100 border border-emerald-200"
          title="Pflanzen-Katalog öffnen"
        >
          <Flower2 size={18} />
          <span className="text-sm font-medium">Pflanzen-Katalog</span>
        </button>
      </div>
    </div>
  );
};

export default PlantTabSidebar;
